import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type ConfirmModalProps = {
    isOpen: boolean;
    title: string;
    body: string;
    dismissLabel: string;
    confirmLabel: string;
    dataAutomationPrefix: string;
    onDismiss: () => void;
    onConfirm: () => void;
    dismissButtonType?: "flat" | "flatDark";
};

export const ConfirmModal = ({
    isOpen,
    title,
    body,
    dismissLabel,
    confirmLabel,
    dataAutomationPrefix,
    onDismiss,
    onConfirm,
    dismissButtonType = "flat",
}: ConfirmModalProps) => (
    <Modal
        isOpen={isOpen}
        onRequestClose={onDismiss}
        data-automation={`${dataAutomationPrefix}-modal`}
        customStyles={{ content: { width: "550px" } }}
    >
        <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Content>
            <Text fontVariant="body1">{body}</Text>
        </Modal.Content>
        <Modal.Footer>
            <Button
                type={dismissButtonType}
                data-automation={`${dataAutomationPrefix}-stay-btn`}
                onClick={onDismiss}
            >
                {dismissLabel}
            </Button>
            <Button
                type="warning"
                data-automation={`${dataAutomationPrefix}-confirm-btn`}
                onClick={onConfirm}
            >
                {confirmLabel}
            </Button>
        </Modal.Footer>
    </Modal>
);
